const recurringInput = {
  repeatEvery: 'Repetir cada',
  repeatOn: 'Repetir en',
  ends: 'Termina',
  endsOn: 'Termina en',

  form: {
    month: 'Mes',
    day: 'Día',
    week: 'Semana',
    year: 'Año',
    occurrences: 'Ocurrencias',
    after: 'Después',
    never: 'Nunca',
    on: 'En',
  },
};

export default recurringInput;
